module.exports = __webpack_public_path__ + "assets/googleplay-badge.7a40eb82.svg";